import CONSTANTS from './constants';

const getHost = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  return window.location.host;
};

export const getRuntimeEnv = () => {
  const nodeEnv = process.env.NODE_ENV;

  const host = getHost();

  if (process.env.REACT_APP_RUN_LOCAL === 'true' || host.includes('localhost')) {
    return CONSTANTS.ENV.LOCAL;
  }

  if (host === CONSTANTS.ENV.DEV_HOST) {
    return CONSTANTS.ENV.DEV;
  }

  if (
    host === CONSTANTS.ENV.STAGING_DEV ||
    host === CONSTANTS.ENV.STAGING_DEV_SAME_DOMAIN ||
    host === CONSTANTS.ENV.STAGING_MASTER
  ) {
    return CONSTANTS.ENV.STAGING;
  }

  return CONSTANTS.ENV.PRODUCTION;
};

export const getApiBaseUrl = () => {
  const runtimeEnv = getRuntimeEnv();

  switch (runtimeEnv) {
    case CONSTANTS.ENV.LOCAL:
      return CONSTANTS.API.DEV;
    case CONSTANTS.ENV.DEV:
      return CONSTANTS.API.DEV;
    case CONSTANTS.ENV.STAGING:
      return CONSTANTS.API.STAGING;
    case CONSTANTS.ENV.PRODUCTION:
    default:
      return CONSTANTS.API.PRODUCTION;
  }
};

export const isProductionEnv = () => getRuntimeEnv() === CONSTANTS.ENV.PRODUCTION;
export const isNonProductionEnv = () => !isProductionEnv();
